import React from 'react'

import { withStyles } from 'material-ui/styles'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography'
import Grid from 'material-ui/Grid'
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  withMobileDialog
} from 'material-ui/Dialog'
import Card, { CardContent } from 'material-ui/Card'
import FormField from './FormField'

import { confirmDelete as confirmDeleteText } from '../constants/messages'
import { styles } from '../styles/components/EditDialog'

class EditDialog extends React.Component {
  constructor(props) {
    super(props)
    const { fields, current = {} } = this.props

    const data = fields.reduce(
      (state, field) =>
        field.type === 'split'
          ? {
              ...state,
              [field.left.key]:
                current[field.left.key] || field.left.default || '',
              [field.right.key]:
                current[field.right.key] || field.right.default || ''
            }
          : {
              ...state,
              [field.key]: current[field.key] || field.default || ''
            },
      {}
    )

    this.state = {
      confirmDelete: false,
      data,
      initialData: JSON.parse(JSON.stringify(data)),
      invalid: {}
    }
  }

  handleClickDelete = () => {
    this.setState({ confirmDelete: true })
  }

  handleCancelDelete = () => {
    this.setState({ confirmDelete: false })
  }

  handleChange = key => value => {
    if (!this.props.readOnly) {
      this.setState({
        data: {
          ...this.state.data,
          [key]: value
        },
        invalid: {
          ...this.state.invalid,
          [key]: false
        }
      })
    }
  }

  handleSubmit = event => {
    event.preventDefault()
    const { data } = this.state
    let formValid = true
    const invalid = {}

    const checkField = field => {
      if (field.validation && !field.validation(data[field.key])) {
        formValid = false
        invalid[field.key] = true
      }
    }

    this.props.fields.forEach(field => {
      if (field.type === 'split') {
        checkField(field.left)
        checkField(field.right)
      } else {
        checkField(field)
      }
    })

    if (formValid) {
      this.props.update(data)
    } else {
      this.setState({ invalid })
    }
  }

  render() {
    const {
      cancel,
      card,
      classes,
      fields,
      fullScreen,
      itemLabel,
      remove,
      open,
      submitLabel,
      title,
      update,
      ...otherProps
    } = this.props
    const { confirmDelete, data, initialData, invalid } = this.state

    const createFormField = (field, index) => (
      <FormField
        key={index}
        field={field}
        error={invalid[field.key] && field.error}
        index={index}
        value={data[field.key]}
        initialValue={initialData[field.key]}
        handleChange={this.handleChange(field.key)}
        options={field.type === 'select' && this.props[field.options.key]}
        disabled={
          typeof field.disabled === 'function'
            ? field.disabled(this.props.current)
            : false
        }
        readOnly={field.readOnly}
        {...otherProps}
      />
    )

    const formContent = (
      <form onSubmit={this.handleSubmit}>
        {fields.map(
          (field, index) =>
            field.type === 'split' ? (
              <Grid container spacing={16} key={index}>
                <Grid item xs={12} sm={6}>
                  {createFormField(field.left)}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {createFormField(field.right)}
                </Grid>
              </Grid>
            ) : (
              createFormField(field, index)
            )
        )}
        <input type="submit" className={classes.hiddenSubmit} />
      </form>
    )

    const formActions = (
      <React.Fragment>
        {remove && (
          <Button onClick={this.handleClickDelete} style={{ color: '#ff0000' }}>
            Delete
          </Button>
        )}
        {cancel && <Button onClick={cancel}>Cancel</Button>}
        {update && (
          <Button onClick={this.handleSubmit}>{submitLabel || 'Save'}</Button>
        )}
      </React.Fragment>
    )

    let deleteActions = null
    if (remove) {
      deleteActions = (
        <React.Fragment>
          <Button onClick={this.handleCancelDelete}>Cancel</Button>
          <Button onClick={remove} style={{ color: '#ff0000' }}>
            Delete
          </Button>
        </React.Fragment>
      )
    }

    return (
      <React.Fragment>
        {card ? (
          <Card className={classes.card}>
            {confirmDelete ? (
              <React.Fragment>
                <CardContent>
                  <Typography variant="headline">Confirm Delete</Typography>
                  {confirmDeleteText(itemLabel)}
                  <DialogActions>{formActions}</DialogActions>
                </CardContent>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <CardContent>
                  <Typography variant="headline">
                    {title || 'Edit Item'}
                  </Typography>
                  {formContent}
                  <div style={{ textAlign: 'right' }}>{formActions}</div>
                </CardContent>
              </React.Fragment>
            )}
          </Card>
        ) : (
          <Dialog
            open={open}
            fullScreen={fullScreen}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
          >
            {confirmDelete ? (
              <React.Fragment>
                <DialogTitle id="form-dialog-title">Confirm Delete</DialogTitle>
                <DialogContent className={classes.dialog}>
                  <DialogContentText>
                    {confirmDeleteText(itemLabel)}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>{deleteActions}</DialogActions>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <DialogTitle id="form-dialog-title">
                  {title || 'Edit Item'}
                </DialogTitle>
                <DialogContent className={classes.dialog}>
                  {formContent}
                </DialogContent>
                <DialogActions>{formActions}</DialogActions>
              </React.Fragment>
            )}
          </Dialog>
        )}
      </React.Fragment>
    )
  }
}

EditDialog.defaultProps = {
  itemLabel: 'record',
  open: true
}

export default withStyles(styles)(withMobileDialog()(EditDialog))



// WEBPACK FOOTER //
// ./src/components/EditDialog.jsx